import { render } from "./RequestStatusBadge.vue?vue&type=template&id=2cab578f&scoped=true"
import script from "./RequestStatusBadge.vue?vue&type=script&lang=js"
export * from "./RequestStatusBadge.vue?vue&type=script&lang=js"

import "./RequestStatusBadge.vue?vue&type=style&index=0&id=2cab578f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cab578f"]])

export default __exports__